/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as UserReportsRouteImport } from './routes/user-reports'
import { Route as TenantsRouteImport } from './routes/tenants'
import { Route as SystemRouteImport } from './routes/system'
import { Route as StagingRouteImport } from './routes/staging'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SectorConfigRouteImport } from './routes/sector-config'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as LogsRouteImport } from './routes/logs'
import { Route as LlmModelsRouteImport } from './routes/llm-models'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as ConversationsRouteImport } from './routes/conversations'
import { Route as ChatTestRouteImport } from './routes/chat-test'
import { Route as BatteryTestRouteImport } from './routes/battery-test'
import { Route as BackupsRouteImport } from './routes/backups'
import { Route as BackofficeUsersRouteImport } from './routes/backoffice-users'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ConversationConversationIdRouteImport } from './routes/conversation.$conversationId'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const UserReportsRoute = UserReportsRouteImport.update({
  id: '/user-reports',
  path: '/user-reports',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsRoute = TenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemRoute = SystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => rootRouteImport,
} as any)
const StagingRoute = StagingRouteImport.update({
  id: '/staging',
  path: '/staging',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SectorConfigRoute = SectorConfigRouteImport.update({
  id: '/sector-config',
  path: '/sector-config',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const LogsRoute = LogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => rootRouteImport,
} as any)
const LlmModelsRoute = LlmModelsRouteImport.update({
  id: '/llm-models',
  path: '/llm-models',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackRoute = FeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const ConversationsRoute = ConversationsRouteImport.update({
  id: '/conversations',
  path: '/conversations',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatTestRoute = ChatTestRouteImport.update({
  id: '/chat-test',
  path: '/chat-test',
  getParentRoute: () => rootRouteImport,
} as any)
const BatteryTestRoute = BatteryTestRouteImport.update({
  id: '/battery-test',
  path: '/battery-test',
  getParentRoute: () => rootRouteImport,
} as any)
const BackupsRoute = BackupsRouteImport.update({
  id: '/backups',
  path: '/backups',
  getParentRoute: () => rootRouteImport,
} as any)
const BackofficeUsersRoute = BackofficeUsersRouteImport.update({
  id: '/backoffice-users',
  path: '/backoffice-users',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConversationConversationIdRoute =
  ConversationConversationIdRouteImport.update({
    id: '/conversation/$conversationId',
    path: '/conversation/$conversationId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/backoffice-users': typeof BackofficeUsersRoute
  '/backups': typeof BackupsRoute
  '/battery-test': typeof BatteryTestRoute
  '/chat-test': typeof ChatTestRoute
  '/conversations': typeof ConversationsRoute
  '/feedback': typeof FeedbackRoute
  '/llm-models': typeof LlmModelsRoute
  '/logs': typeof LogsRoute
  '/products': typeof ProductsRoute
  '/sector-config': typeof SectorConfigRoute
  '/settings': typeof SettingsRoute
  '/staging': typeof StagingRoute
  '/system': typeof SystemRoute
  '/tenants': typeof TenantsRoute
  '/user-reports': typeof UserReportsRoute
  '/users': typeof UsersRoute
  '/conversation/$conversationId': typeof ConversationConversationIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/backoffice-users': typeof BackofficeUsersRoute
  '/backups': typeof BackupsRoute
  '/battery-test': typeof BatteryTestRoute
  '/chat-test': typeof ChatTestRoute
  '/conversations': typeof ConversationsRoute
  '/feedback': typeof FeedbackRoute
  '/llm-models': typeof LlmModelsRoute
  '/logs': typeof LogsRoute
  '/products': typeof ProductsRoute
  '/sector-config': typeof SectorConfigRoute
  '/settings': typeof SettingsRoute
  '/staging': typeof StagingRoute
  '/system': typeof SystemRoute
  '/tenants': typeof TenantsRoute
  '/user-reports': typeof UserReportsRoute
  '/users': typeof UsersRoute
  '/conversation/$conversationId': typeof ConversationConversationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/backoffice-users': typeof BackofficeUsersRoute
  '/backups': typeof BackupsRoute
  '/battery-test': typeof BatteryTestRoute
  '/chat-test': typeof ChatTestRoute
  '/conversations': typeof ConversationsRoute
  '/feedback': typeof FeedbackRoute
  '/llm-models': typeof LlmModelsRoute
  '/logs': typeof LogsRoute
  '/products': typeof ProductsRoute
  '/sector-config': typeof SectorConfigRoute
  '/settings': typeof SettingsRoute
  '/staging': typeof StagingRoute
  '/system': typeof SystemRoute
  '/tenants': typeof TenantsRoute
  '/user-reports': typeof UserReportsRoute
  '/users': typeof UsersRoute
  '/conversation/$conversationId': typeof ConversationConversationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/backoffice-users'
    | '/backups'
    | '/battery-test'
    | '/chat-test'
    | '/conversations'
    | '/feedback'
    | '/llm-models'
    | '/logs'
    | '/products'
    | '/sector-config'
    | '/settings'
    | '/staging'
    | '/system'
    | '/tenants'
    | '/user-reports'
    | '/users'
    | '/conversation/$conversationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/backoffice-users'
    | '/backups'
    | '/battery-test'
    | '/chat-test'
    | '/conversations'
    | '/feedback'
    | '/llm-models'
    | '/logs'
    | '/products'
    | '/sector-config'
    | '/settings'
    | '/staging'
    | '/system'
    | '/tenants'
    | '/user-reports'
    | '/users'
    | '/conversation/$conversationId'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/backoffice-users'
    | '/backups'
    | '/battery-test'
    | '/chat-test'
    | '/conversations'
    | '/feedback'
    | '/llm-models'
    | '/logs'
    | '/products'
    | '/sector-config'
    | '/settings'
    | '/staging'
    | '/system'
    | '/tenants'
    | '/user-reports'
    | '/users'
    | '/conversation/$conversationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRoute: typeof AnalyticsRoute
  BackofficeUsersRoute: typeof BackofficeUsersRoute
  BackupsRoute: typeof BackupsRoute
  BatteryTestRoute: typeof BatteryTestRoute
  ChatTestRoute: typeof ChatTestRoute
  ConversationsRoute: typeof ConversationsRoute
  FeedbackRoute: typeof FeedbackRoute
  LlmModelsRoute: typeof LlmModelsRoute
  LogsRoute: typeof LogsRoute
  ProductsRoute: typeof ProductsRoute
  SectorConfigRoute: typeof SectorConfigRoute
  SettingsRoute: typeof SettingsRoute
  StagingRoute: typeof StagingRoute
  SystemRoute: typeof SystemRoute
  TenantsRoute: typeof TenantsRoute
  UserReportsRoute: typeof UserReportsRoute
  UsersRoute: typeof UsersRoute
  ConversationConversationIdRoute: typeof ConversationConversationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-reports': {
      id: '/user-reports'
      path: '/user-reports'
      fullPath: '/user-reports'
      preLoaderRoute: typeof UserReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants': {
      id: '/tenants'
      path: '/tenants'
      fullPath: '/tenants'
      preLoaderRoute: typeof TenantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system': {
      id: '/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof SystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staging': {
      id: '/staging'
      path: '/staging'
      fullPath: '/staging'
      preLoaderRoute: typeof StagingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sector-config': {
      id: '/sector-config'
      path: '/sector-config'
      fullPath: '/sector-config'
      preLoaderRoute: typeof SectorConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logs': {
      id: '/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof LogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/llm-models': {
      id: '/llm-models'
      path: '/llm-models'
      fullPath: '/llm-models'
      preLoaderRoute: typeof LlmModelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversations': {
      id: '/conversations'
      path: '/conversations'
      fullPath: '/conversations'
      preLoaderRoute: typeof ConversationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat-test': {
      id: '/chat-test'
      path: '/chat-test'
      fullPath: '/chat-test'
      preLoaderRoute: typeof ChatTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/battery-test': {
      id: '/battery-test'
      path: '/battery-test'
      fullPath: '/battery-test'
      preLoaderRoute: typeof BatteryTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backups': {
      id: '/backups'
      path: '/backups'
      fullPath: '/backups'
      preLoaderRoute: typeof BackupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/backoffice-users': {
      id: '/backoffice-users'
      path: '/backoffice-users'
      fullPath: '/backoffice-users'
      preLoaderRoute: typeof BackofficeUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversation/$conversationId': {
      id: '/conversation/$conversationId'
      path: '/conversation/$conversationId'
      fullPath: '/conversation/$conversationId'
      preLoaderRoute: typeof ConversationConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRoute: AnalyticsRoute,
  BackofficeUsersRoute: BackofficeUsersRoute,
  BackupsRoute: BackupsRoute,
  BatteryTestRoute: BatteryTestRoute,
  ChatTestRoute: ChatTestRoute,
  ConversationsRoute: ConversationsRoute,
  FeedbackRoute: FeedbackRoute,
  LlmModelsRoute: LlmModelsRoute,
  LogsRoute: LogsRoute,
  ProductsRoute: ProductsRoute,
  SectorConfigRoute: SectorConfigRoute,
  SettingsRoute: SettingsRoute,
  StagingRoute: StagingRoute,
  SystemRoute: SystemRoute,
  TenantsRoute: TenantsRoute,
  UserReportsRoute: UserReportsRoute,
  UsersRoute: UsersRoute,
  ConversationConversationIdRoute: ConversationConversationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
